import info_fill from '@material-design-icons/svg/filled/info.svg'
import local_mall from '@material-design-icons/svg/filled/local_mall.svg'
import location from '@material-design-icons/svg/filled/location_on.svg'
import person from '@material-design-icons/svg/filled/person.svg'
import person_search from '@material-design-icons/svg/filled/person_search.svg'
import abc from '@material-design-icons/svg/outlined/abc.svg'
import add from '@material-design-icons/svg/outlined/add.svg'
import add_circle from '@material-design-icons/svg/outlined/add_circle_outline.svg'
import arrow_back from '@material-design-icons/svg/outlined/arrow_back.svg'
import arrow_downward from '@material-design-icons/svg/outlined/arrow_downward.svg'
import arrow_forward from '@material-design-icons/svg/outlined/arrow_forward.svg'
import arrow_upward from '@material-design-icons/svg/outlined/arrow_upward.svg'
import autorenew from '@material-design-icons/svg/outlined/autorenew.svg'
import check from '@material-design-icons/svg/outlined/check.svg'
import close from '@material-design-icons/svg/outlined/close.svg'
import content_copy from '@material-design-icons/svg/outlined/content_copy.svg'
import delete_svg from '@material-design-icons/svg/outlined/delete.svg'
import east from '@material-design-icons/svg/outlined/east.svg'
import edit from '@material-design-icons/svg/outlined/edit.svg'
import info from '@material-design-icons/svg/outlined/info.svg'
import ios_share from '@material-design-icons/svg/outlined/ios_share.svg'
import keyboard_arrow_down from '@material-design-icons/svg/outlined/keyboard_arrow_down.svg'
import keyboard_arrow_left from '@material-design-icons/svg/outlined/keyboard_arrow_left.svg'
import keyboard_arrow_right from '@material-design-icons/svg/outlined/keyboard_arrow_right.svg'
import keyboard_arrow_up from '@material-design-icons/svg/outlined/keyboard_arrow_up.svg'
import link from '@material-design-icons/svg/outlined/link.svg'
import logout from '@material-design-icons/svg/outlined/logout.svg'
import photo_camera from '@material-design-icons/svg/outlined/photo_camera.svg'
import qr_code from '@material-design-icons/svg/outlined/qr_code.svg'
import shopping_bag from '@material-design-icons/svg/outlined/shopping_bag.svg'
import sort from '@material-design-icons/svg/outlined/sort.svg'
import swap_vert from '@material-design-icons/svg/outlined/swap_vert.svg'
import unfold_more from '@material-design-icons/svg/outlined/unfold_more.svg'
import west from '@material-design-icons/svg/outlined/west.svg'
import ai from 'asset/icon-ai.svg'
import apparel from 'asset/icon-apparel.svg'
import barcode from 'asset/icon-barcode.svg'
import check_circle from 'asset/icon-check-circle.svg'
import checkroom from 'asset/icon-checkroom.svg'
import combo_basket from 'asset/icon-combo-basket.svg'
import download from 'asset/icon-download.svg'
import dress_female from 'asset/icon-dress-female.svg'
import dress_male from 'asset/icon-dress-male.svg'
import favorite_fill from 'asset/icon-favorite-fill.svg'
import favorite from 'asset/icon-favorite.svg'
import filter from 'asset/icon-filter.svg'
import search from 'asset/icon-search.svg'
import thumb_up_fill from 'asset/icon-thumb-up-fill.svg'

export type IconName =
  | 'abc'
  | 'add'
  | 'add_circle'
  | 'ai'
  | 'apparel'
  | 'arrow_back'
  | 'arrow_downward'
  | 'arrow_forward'
  | 'arrow_upward'
  | 'autorenew'
  | 'barcode'
  | 'check'
  | 'check_circle'
  | 'checkroom'
  | 'close'
  | 'combo_basket'
  | 'content_copy'
  | 'delete'
  | 'download'
  | 'dress_female'
  | 'dress_male'
  | 'east'
  | 'edit'
  | 'favorite'
  | 'favorite_fill'
  | 'filter'
  | 'info'
  | 'info_fill'
  | 'ios_share'
  | 'keyboard_arrow_down'
  | 'keyboard_arrow_left'
  | 'keyboard_arrow_right'
  | 'keyboard_arrow_up'
  | 'link'
  | 'local_mall'
  | 'location'
  | 'logout'
  | 'person'
  | 'person_search'
  | 'photo_camera'
  | 'qr_code'
  | 'search'
  | 'shopping_bag'
  | 'sort'
  | 'swap_vert'
  | 'thumb_up_fill'
  | 'unfold_more'
  | 'west'

export function getSvg(name: IconName) {
  // @formatter:off
  switch (name) {
    case 'abc': return abc
    case 'add': return add
    case 'add_circle': return add_circle
    case 'ai': return ai
    case 'apparel': return apparel
    case 'arrow_back': return arrow_back
    case 'arrow_downward': return arrow_downward
    case 'arrow_forward': return arrow_forward
    case 'arrow_upward': return arrow_upward
    case 'autorenew': return autorenew
    case 'barcode': return barcode
    case 'check': return check
    case 'check_circle': return check_circle
    case 'checkroom': return checkroom
    case 'close': return close
    case 'combo_basket': return combo_basket
    case 'content_copy': return content_copy
    case 'delete': return delete_svg
    case 'download': return download
    case 'dress_female': return dress_female
    case 'dress_male': return dress_male
    case 'east': return east
    case 'edit': return edit
    case 'favorite': return favorite
    case 'favorite_fill': return favorite_fill
    case 'filter': return filter
    case 'info': return info
    case 'info_fill': return info_fill
    case 'ios_share': return ios_share
    case 'keyboard_arrow_down': return keyboard_arrow_down
    case 'keyboard_arrow_left': return keyboard_arrow_left
    case 'keyboard_arrow_right': return keyboard_arrow_right
    case 'keyboard_arrow_up': return keyboard_arrow_up
    case 'link': return link
    case 'local_mall': return local_mall
    case 'location': return location
    case 'logout': return logout
    case 'person': return person
    case 'person_search': return person_search
    case 'photo_camera': return photo_camera
    case 'qr_code': return qr_code
    case 'search': return search
    case 'shopping_bag': return shopping_bag
    case 'sort': return sort
    case 'swap_vert': return swap_vert
    case 'thumb_up_fill': return thumb_up_fill
    case 'unfold_more': return unfold_more
    case 'west': return west
    default:
      console.error('unknown icon', name)
      return undefined
  }
  // @formatter:on
}
